import CryptoJS from 'crypto-js';

export function encryptPassword(password: string) {
  const privateKey = 'U2FsdGVkX1+bvnW0cY0RlhO2g84knJUHpA/BUSbkslzFrX0kqlv';
  return CryptoJS.AES.encrypt(password, privateKey).toString();
}
